import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { Alert as AlertProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import UiKitAlert from '@ui-kit/components/Alert'

export const Alert = (props: AlertProps & { flowValues: FlowValues }) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })

  const translatedMessage = translateFunction(props.message)
  const translatedTitle = props.title ? translateFunction(props.title) : undefined

  return (
    <View>
      <UiKitAlert
        id={props.id}
        title={translatedTitle}
        message={translatedMessage}
        variant={props.variant}
      />
    </View>
  )
}
